import './switchComponent.scss'
import React from 'react';
import {Switch} from "@mui/material";

interface SwitchComponentProps {
    checked?: boolean,
    onUpdate?: Function,
    disabled?:boolean,
    readOnly?: boolean,
    color?: "primary" | "secondary" | "info" | "success" | undefined;
    size?: "small" | "medium" | undefined
}

const SwitchComponent = (props: SwitchComponentProps) => {
        const {checked, onUpdate,disabled,readOnly} = props
        let {color, size} = props
        if (!color) color = "success";
        if (!size) size = "small";


        return (
            <div>
                <Switch
                    disabled={disabled}
                    size={size}
                    color={color}
                    readOnly={readOnly}
                    checked={checked}
                    onChange={(value) => {
                        if (onUpdate) {
                            onUpdate(value.target.checked)
                        }
                    }}
                    inputProps={{'aria-label': 'controlled'}}
                />
            </div>
        )

    }

;

export default SwitchComponent;